/** Normalize Tezam/PA color strings to CSS hex. */
export function normalizeEventHex(
  color: string | undefined | null,
  fallback = "#4f46e5",
): string {
  let c = (color ?? "").trim();
  if (!c) return fallback;

  if (c.startsWith("rgb")) {
    const m = c.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (m) {
      const hex = [m[1], m[2], m[3]]
        .map((n) => Number(n).toString(16).padStart(2, "0"))
        .join("");
      return `#${hex}`;
    }
  }

  if (c.startsWith("#")) c = c.slice(1);
  c = c.replace(/^0x/i, "");
  if (/^[0-9a-fA-F]{3}$/.test(c) || /^[0-9a-fA-F]{6}$/.test(c) || /^[0-9a-fA-F]{8}$/.test(c)) {
    return `#${c}`;
  }
  return fallback;
}

export function applyEventPrimaryCssVar(color: string | undefined | null): string {
  const primary = normalizeEventHex(color);
  if (typeof document !== "undefined") {
    document.documentElement.style.setProperty("--event-primary", primary);
  }
  return primary;
}

/** Expand #RGB / #RRGGBB / #RRGGBBAA to 6-digit #RRGGBB. */
export function eventHexRgb(color: string | undefined | null, fallback = "#4f46e5"): string {
  const n = normalizeEventHex(color, fallback).replace(/^#/, "");
  if (n.length === 3) {
    return `#${n[0]}${n[0]}${n[1]}${n[1]}${n[2]}${n[2]}`;
  }
  return `#${n.slice(0, 6)}`;
}

/** `#RRGGBB` + 2-digit hex alpha (e.g. "55"). */
export function eventHexAlpha(
  color: string | undefined | null,
  alphaHex: string,
  fallback = "#4f46e5",
): string {
  return `${eventHexRgb(color, fallback)}${alphaHex}`;
}

export function eventHexRgba(
  color: string | undefined | null,
  alpha: number,
  fallback = "#4f46e5",
): string {
  const hex = eventHexRgb(color, fallback).slice(1);
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const a = Math.min(1, Math.max(0, alpha));
  return `rgba(${r},${g},${b},${a})`;
}
